module.exports = __webpack_public_path__ + "static/media/MyPethealth_Privacy_Policy_US.a36d1f33.pdf";